export default __webpack_public_path__ + "videos/particle-glow-trail-silver-1920w.e139330675ee11ad3ed9e63b8f37a64c.webm";